exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable td[data-v-349ee62a] {\n    vertical-align: middle !important;\n}\n#dropzone[data-v-349ee62a] {\n  height: 250px;\n}\n", ""]);

// exports
